import { Component, OnInit, Input } from '@angular/core';
import { JDCalMehtodViewModel, CalculationMethodType } from '../../model/measurement-points.model';

@Component({
  selector: 'jd-cal-method',
  templateUrl: './jd-cal-method.component.html',
  styleUrls: ['./jd-cal-method.component.scss']
})
export class JdCalMethodComponent implements OnInit {



  constructor() { }

  ngOnInit() {
    if(this.jdCalMethod== undefined)
      this.jdCalMethod = new JDCalMehtodViewModel();
  }


  @Input() jdCalMethod : JDCalMehtodViewModel;

  

}
